<template>
  <div class="view pa24">
    <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :before-close="closeDialog">
      <el-form :model="ruleForm" :rules="rules" ref="dealerRuleForm" label-width="100px" class="ruleForm">
        <el-form-item label="经销商">
          <el-select v-model="ruleForm.dealerId" placeholder="请选择经销商" @change="handleDealerChange(ruleForm.dealerId)">
            <el-option v-for="dealer in dealerList" :key="dealer.id" :label="dealer.dealerName" :value="dealer.id" />
          </el-select>
        </el-form-item>
        <!-- 设备名称 -->
        <el-form-item label="设备名称" prop="deviceName" v-if="dispaly">
          <el-input v-model="ruleForm.deviceName"></el-input>
        </el-form-item>
        <el-form-item label="订单" prop="orderNo">
          <el-input v-model="ruleForm.orderNo"></el-input>
        </el-form-item>
        <el-form-item label="发货地址" prop="shipmentPlace">
          <el-input v-model="ruleForm.shipmentPlace"></el-input>
        </el-form-item>
        <el-form-item label="收货地址" prop="receiptPlace">
          <el-input v-model="ruleForm.receiptPlace"></el-input>
        </el-form-item>
        <el-form-item label="IMEI" prop="imei">
          <el-input v-model="ruleForm.imei" :disabled="flag"></el-input>
        </el-form-item>
        <el-form-item label="预计送达时间" prop="transportTime">
          <el-date-picker v-model="ruleForm.transportTime" type="datetime" placeholder="选择到达时间"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <!-- 增加一个途径地  一个地区选择器  可以添加多个-->
        <el-form-item :label="'途径区域'+ (index+1)" v-for="(item, index) in ruleForm.areaArr" :key="item.county"
          :prop="'areaArr.' + index + '.data'" :rules=" source == 'daili' ? [
                     { required: true, message: '请选择途径区域', trigger: 'blur' },
                   ] : []">
          <el-cascader size="large" :options="options" v-model="item.data" @change="handleChange(index, arguments)"
            placeholder="请选择省市区" clearable :props="{ checkStrictly: true }"></el-cascader>
          <el-button class="ml10" @click="delItem(index)" v-if="index > 0">删除</el-button>
        </el-form-item>
        <el-button @click="addItem()" style="margin-left: 20px;">添加途径区域</el-button>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss" @click="confirmAddDealer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { add, fetchDealerAddress } from '@/api/gps.js'
  import { fetchDealList } from '@/api/companyManage.js'
  import { selectOrdersInfoPc } from '@/api/order.js'
  import {
    regionData,
    CodeToText,
  } from 'element-china-area-data'

  export default {
    name: "deviceDialog",
    components: {
      // BaiduMap,
      // Map
    },
    props: [],

    data() {
      return {
        dealerList: [],
        flag: false,
        source: '',
        //测试
        provinces: [],
        dialogVisible: false,
        options: regionData,
        title: '添加设备',
        ruleForm: {
          id: '',
          deviceName: '',
          iccid: '',
          imei: '',
          remarks: null,
          coordinate: {
            lng: '',
            lat: ''
          },
          province: '',
          city: '',
          county: '',
          areaArr: [
            {
              province: '',
              city: '',
              county: '',
              data: [],
              address: ''
            }
          ],
          orderNo: '',
          shipmentPlace: '',
          status: '',
          receiptPlace: '',
          version: '',
          dealerId: '',
          operator: '',
          transportTime: ''
        },
        rules: {
          imei: [
            { required: true, message: '请输入IMEI号', trigger: 'blur' },
          ],
          dealerId: [
            { required: true, message: '请输入IMEI号', trigger: 'blur' },
          ],
          // transportTime: [
          //   { validator: this.validateTransportTime, trigger: ['blur'] }
          // ],
        },
        mapZoom: 15,
        mapCenter: { lng: 0, lat: 0 },
        selectedOptions: [],
        type: 'add',
        id: '',
        dispaly: false

      };
    },
    onShow() {

    },
    mounted() {
      this.getDealerList()
    },
    methods: {
      getNullArea() {
        let obj = {
          province: '',
          city: '',
          county: '',
          data: [],
          address: ''
        }
        return obj
      },
      addItem(index) {
        // this.ruleForm.areaArr.splice(index, 0, this.getNullArea())
        this.ruleForm.areaArr.push(this.getNullArea())
      },
      delItem(index) {
        this.ruleForm.areaArr.splice(index, 1)
      },

      updateLocation(Addr) {
        // console.log('Addr+++++++++++++++++++++++++', Addr)
        this.ruleForm.address = Addr.orgAddr
        // console.log('this.ruleForm.address', this.ruleForm.address)
        this.$refs.dealerRuleForm.validateField(["address"], (valid, vv) => {
          // console.log('------valid------',valid)
          // if(!valid){
          //   console.log("校验成功")
          // }
        });

        this.ruleForm.coordinate.lng = Addr.lon
        this.ruleForm.coordinate.lat = Addr.lat
        this.ruleForm.province = Addr.province
        this.ruleForm.city = Addr.city
        this.ruleForm.county = Addr.district
        document.querySelector('.search-box-wrapper input').value = this.ruleForm.address
      },
      openDialog(type, data) {
        this.flag = false
        this.dialogVisible = true
        let v = this
        if (type === 'add') {
          this.title = '添加设备'
          this.type = 'add'
          this.id = ''
          this.dispaly = false
        } else {
          this.title = '编辑设备'
          this.getData(data)
          this.type = "edit"
          this.id = data.id
          this.flag = true
          this.dispaly = true
        }
      },
      closeDialog() {
        this.dialogVisible = false
        this.resetForm()
        // 清理表单数据
        this.ruleForm = {
          id: '',
          deviceName: '',
          iccid: '',
          imei: '',
          remarks: null,
          coordinate: {
            lng: '',
            lat: ''
          },
          province: '',
          city: '',
          county: '',
          areaArr: [
            {
              province: '',
              city: '',
              county: '',
              data: [],
              address: ''
            }
          ],
          orderNo: '',
          shipmentPlace: '',
          status: '',
          receiptPlace: '',
          version: '',
          dealerId: '',
          operator: '',
          transportTime: ''
        }
        this.type = 'add'
        this.id = ''
        this.flag = false
        this.dispaly = false
        this.$emit('getList')
      },
      resetForm() {
        this.$refs.dealerRuleForm.resetFields();
      },
      // 获取省市区
      getCity(lng, lat) {
        let vm = this
        return new Promise((resolve, reject) => {
          var geocoder = new AMap.Geocoder({
            radius: 100,
            extensions: "all",
          });
          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                console.log("搜索获取地址的数据-----", result);
                vm.ruleForm.province = result.regeocode.addressComponent.province;
                vm.ruleForm.city = result.regeocode.addressComponent.city;
                vm.ruleForm.county = result.regeocode.addressComponent.district;
                resolve()
              }
            }
          })

        })

      },
      confirmAddDealer() {
        this.$refs.dealerRuleForm.validate((valid) => {
          if (valid) {
            // this.getCity(this.ruleForm.coordinate.lng, this.ruleForm.coordinate.lat).then(res => {
            const isAreaArrEmpty = this.ruleForm.areaArr.every(item => {
              return (
                item.province === '' &&
                item.city === '' &&
                item.county === '' &&
                item.data.length === 0 &&
                item.address === ''
              );
            });
            let areaArr = null
            if (isAreaArrEmpty) {
              areaArr = []
            } else {
              areaArr = this.ruleForm.areaArr
            }
            let params = {
              iccid: this.ruleForm.iccid,
              deviceName: this.ruleForm.deviceName,
              imei: this.ruleForm.imei,
              orderNo: this.ruleForm.orderNo,
              shipmentPlace: this.ruleForm.shipmentPlace,
              receiptPlace: this.ruleForm.receiptPlace,
              dealerId: this.ruleForm.dealerId,
              operator: this.ruleForm.operator,
              transportTime: this.ruleForm.transportTime,
              deviceAreas: areaArr
            }
            if (this.type === 'edit') {
              params.id = this.id
            }
            console.log('params', params)
            add(params).then(res => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.closeDialog()
              }
            })

            // })

          }
        })
      },
      // 回显
      getData(data) {
        this.ruleForm.areaArr = data.deviceAreas.map(item => {
          let data = []
          if (item.province) {
            data.push(item.province)
            if (item.city) {
              data.push(item.city)
              if (item.county) {
                data.push(item.county)
              }
            }
          }
          return {
            ...item,
            data: data
          }
        })
        this.ruleForm.deviceName = data.deviceName
        this.ruleForm.remarks = data.remarks
        this.ruleForm.iccid = data.iccid
        this.ruleForm.imei = data.imei,
          this.ruleForm.orderNo = data.orderNo,
          this.ruleForm.shipmentPlace = data.shipmentPlace,
          this.ruleForm.receiptPlace = data.receiptPlace,
          this.ruleForm.status = data.status,
          this.ruleForm.version = data.version,
          this.ruleForm.vbat = data.vbat,
          this.ruleForm.temp = data.temp,
          this.ruleForm.dealerId = data.dealerId,
          this.ruleForm.operator = data.operator
        this.ruleForm.transportTime = data.transportTime
        if (this.ruleForm.address) {
          var that = this
          setTimeout(function () {
            document.querySelector('.search-box-wrapper input').value = that.ruleForm.address
          }, 500)
        }

      },
      handleChange(index, e) {
        let value = e[0]
        this.ruleForm.areaArr[index].province = value[0] ? value[0] : ''
        this.ruleForm.areaArr[index].city = value[1] ? value[1] : ''
        this.ruleForm.areaArr[index].county = value[2] ? value[2] : ''
        let address = ''
        if (value[0]) {
          address += CodeToText[value[0]]
          if (value[1]) {
            address += CodeToText[value[1]]
            if (value[2]) {
              address += CodeToText[value[2]]
            }
          }
        }
        this.ruleForm.areaArr[index].address = address
        // this.ruleForm.areaArr[index].address = CodeToText[(value[0] ? value[0] : '')] + CodeToText[(value[1]?value[1]:'')] + CodeToText[(value[2] ? value[2] : '')]
        console.log('采集到的数据', this.ruleForm.areaArr)
      },
      handlerBMap({ BMap, map }) {
        this.BMap = BMap
        this.map = map
        if (this.ruleForm.coordinate && this.ruleForm.coordinate.lng) {
          this.mapCenter.lng = this.ruleForm.coordinate.lng
          this.mapCenter.lat = this.ruleForm.coordinate.lat
          this.mapZoom = 15
          map.addOverlay(new this.BMap.Marker(this.ruleForm.coordinate))
        } else {
          this.mapCenter.lng = 113.271429
          this.mapCenter.lat = 23.135336
          this.mapZoom = 10
        }
      },

      querySearch(queryString, cb) {
        var that = this
        var myGeo = new this.BMap.Geocoder()
        myGeo.getPoint(queryString, function (point) {
          if (point) {
            that.ruleForm.coordinate = point
            that.makerCenter(point)
          } else {
            that.ruleForm.coordinate = null
          }
        }, this.locationCity)
        var options = {
          onSearchComplete: function (results) {
            if (local.getStatus() === 0) {
              // 判断状态是否正确
              var s = []
              for (var i = 0; i < results.getCurrentNumPois(); i++) {
                var x = results.getPoi(i)
                var item = { value: x.address + x.title, point: x.point }
                s.push(item)
                cb(s)
              }
            } else {
              cb()
            }
          }
        }
        var local = new this.BMap.LocalSearch(this.map, options)
        local.search(queryString)
      },
      handleSelect(item) {
        var { point } = item
        this.ruleForm.coordinate = point
        this.makerCenter(point)
      },
      makerCenter(point) {
        if (this.map) {
          this.map.clearOverlays()
          this.map.addOverlay(new this.BMap.Marker(point))
          this.mapCenter.lng = point.lng
          this.mapCenter.lat = point.lat
          this.mapZoom = 15
        }
      },
      getDealerList() {
        let params = {
          companyId: JSON.parse(localStorage.getItem('info')).companyId,
          type: 2,
        }
        fetchDealList(params).then(res => {
          console.log(res.data.list);
          if (res.data) {
            this.dealerList = res.data.list
          }
        })
      },
      handleDealerChange(dealerId) {
        console.log('dealerId', dealerId);
        let params = {
          dealerId: dealerId,
        }
        fetchDealerAddress(params).then(res => {
          console.log('获取经销商地址成功', res);
          this.ruleForm.receiptPlace = res.data.address;
          this.ruleForm.shipmentPlace = res.data.dealerAreas[0].address;

        }).catch(err => {
          console.error('获取经销商地址失败', err);
        });
      },
      // validateTransportTime(rule, value, callback) {
      //   if (this.ruleForm.areaArr && this.ruleForm.areaArr.length > 0 && this.ruleForm.areaArr[0].address != "" && !value) {
      //     callback(new Error('请选择预计送达时间'));
      //   } else {
      //     callback();
      //   }
      // },
    },



  };
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10 rpx;
  }
</style>